export default __webpack_public_path__ + "static/media/no_record.e1867a82.png";